<template>
  <NBox v-for="row in rowNumber" :key="row" class="py-4 mb-2 px-2 w-full">
    <div class="flex justify-around gap-3 w-full">
      <template v-for="column in columnNumber" :key="column">
        <slot>
          <TextSkeleton width="50px" />
        </slot>
      </template>
    </div>
  </NBox>
</template>

<script setup lang="ts">
import TextSkeleton from '@/components/TextSkeleton.vue';

type TableSkeletonProps = {
  rowNumber?: number;
  columnNumber?: number;
};
withDefaults(defineProps<TableSkeletonProps>(), {
  columnNumber: 1,
  rowNumber: 1,
});
</script>
